import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import {
  CreditModelScenarioMapping,
  ScenarioType,
  STOCHASTIC_SCENARIO,
} from '../../credit/model/credit-portfolio.model'
import { SelectedScenario } from '../../credit/model/credit-results.model'
import { sortModelScenarioMapping } from '../../credit/utils/credit.utils'

@Component({
  selector: 'app-scenario-selector',
  templateUrl: './scenario-selector.component.html',
})
export class ScenarioSelectorComponent {
  sortModelScenarioMapping = sortModelScenarioMapping
  mappings: CreditModelScenarioMapping[] = []
  mapping: CreditModelScenarioMapping

  constructor(
    public dialogRef: MatDialogRef<ScenarioSelectorComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      mappingScenarioId: number
      modelScenarioMappings: CreditModelScenarioMapping[]
    },
  ) {
    this.mappings = this.data.modelScenarioMappings
    this.mapping = this.data.modelScenarioMappings.find(
      (mapping) => mapping.id === this.data.mappingScenarioId,
    )
    if (!this.mapping) {
      return
    }
  }

  onSelectedChange(datumId: string): void {
    const selected = this.mappings.find((mapping) => mapping.id === Number(datumId))
    if (!selected) {
      return
    }
    this.mapping = selected
  }

  onApplyClick(): void {
    if (!this.mapping) {
      return
    }
    const output: SelectedScenario = {
      id: '',
      model: this.mapping.model_name,
      name: this.mapping.scenario_name,
      scenario: this.mapping.scenario_name,
      scenarioType:
        this.mapping.scenario_name === STOCHASTIC_SCENARIO
          ? ScenarioType.Stochastic
          : ScenarioType.Deterministic,
      mappingScenarioId: this.mapping.id,
      returnPeriod: this.mapping.return_period,
    }
    this.dialogRef.close(output)
  }
}
